import { render, staticRenderFns } from "./BaseFileInput.vue?vue&type=template&id=815eff3a"
import script from "./BaseFileInput.vue?vue&type=script&lang=ts"
export * from "./BaseFileInput.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports